import React from "react";
import { footerCopyright } from "data/footer/translationFooter";
import { useLanguagesContext } from "hooks/useContextAll";

const Footer = () => {
    const language = useLanguagesContext();

    const currentYear = new Date().getFullYear();
    return (
        <footer className="footer">
            <p>
                &copy; {currentYear} <span className="footer-logo">Yozu</span> -{" "}
                {footerCopyright[language.language]}
            </p>
        </footer>
    );
};

export default Footer;
